import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoutes from "../../core/routes/PrivateRoutes";
import { Layout } from "../../core/components/Layout";
import { Entrega } from "../pages/Entrega";
import { AlterarNumeroMesas } from "../pages/AlterarNumeroMesas";
import { MetodosPagamento } from "../../pedidos/pages/MetodosPagamento";
import { Maquininhas } from "../../pedidos/pages/Maquininhas";
import { BandeirasCartao } from "../../pedidos/pages/BandeirasCartao";
import { ConfiguracoesPedidoProvider } from "../../pedidos/contexts/ConfiguracoesPedidoContext";
import { Contabilidade } from "../pages/Contabilidade";
import { Tema } from "../pages/Tema";
import { TempoEntrega } from "../pages/TempoEntrega";
import { TaxaServico } from "../pages/TaxaServico";

interface IConfiguracoesProps {
  autenticado: boolean;
}

export const ConfiguracoesRoutes = ({ autenticado }: IConfiguracoesProps) => {
  return (
    <ConfiguracoesPedidoProvider>
      <Routes>
        <Route
          element={
            <Layout titulo="Configurações">
              <PrivateRoutes autenticado={autenticado} />
            </Layout>
          }
        >
          <Route path="/" element={<Navigate to="/configuracoes/metodos-pagamento" replace />} />
          <Route path="/fluxo/operacao" element={<Navigate to="/cozinha/fluxo/operacao" replace />} />
          <Route path="/entrega" element={<Entrega />} />
          <Route path="/numero-mesas" element={<AlterarNumeroMesas />} />
          <Route path="/metodos-pagamento" element={<MetodosPagamento />} />
          <Route path="/maquininhas" element={<Maquininhas />} />
          <Route path="/bandeiras" element={<BandeirasCartao />} />
          <Route path="/contabilidade" element={<Contabilidade />} />
          <Route path="/tema" element={<Tema />} />
          <Route path="/tempo-entrega" element={<TempoEntrega />} />
          <Route path="/taxa-servico" element={<TaxaServico />} />
          <Route path="/kds" element={<Navigate to="/cozinha/configuracao" replace />} />
          <Route path="*" element={<Navigate to="/pagina-nao-encontrada" />} />
        </Route>
      </Routes>
    </ConfiguracoesPedidoProvider>
  );
};
